
module.exports.InvalidParameter = class InvalidParameter extends Error {
    constructor(message) {
        super(message); // (1)
        this.name = "InvalidParameter"; // (2)
    }
}


module.exports.InvalidJSONFormat = class InvalidJSONFormat extends Error {
    constructor(message) {
        super(message); // (1)
        this.name = "InvalidJSONFormat"; // (2)
    }
}


module.exports.MalformedMarkup = class MalformedMarkup extends Error {
    constructor(message) {
        super(message); // (1)
        this.name = "MalformedMarkup"; // (2)
    }
}



module.exports.MalformedBoilerPlateHTML = class MalformedBoilerPlateHTML extends Error {
    constructor(message) {
        super(message); // (1)
        this.name = "MalformedBoilerPlateHTML"; // (2)
    }
}

//
module.exports.StripeCardError = class StripeCardError extends Error {
    constructor(message) {
        super(message); // (1)
        this.name = "StripeCardError"; // (2)
    }
}

//
module.exports.ValidateError = class ValidateError extends Error {
    constructor(message) {
        super(message); // (1)
        this.name = "ValidateError"; // (2)
    }
}

module.exports.StripeCheckoutError = class StripeCheckoutError extends Error {
    constructor(message) {
        super(message); // (1)
        this.name = "StripeCheckoutError"; // (2)
    }
}
